/**
 * @generated SignedSource<<8fb0fb9c21d73bd7db702967401fdf61>>
 * @relayHash c3a67771732db6cf4daf1278e005a576
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c3a67771732db6cf4daf1278e005a576

import { ConcreteRequest } from 'relay-runtime';
export type useDeMedicationSearchQuery$variables = {
  searchTerm: string;
};
export type useDeMedicationSearchQuery$data = {
  readonly de_preparations: {
    readonly result?: ReadonlyArray<{
      readonly composition: ReadonlyArray<string>;
      readonly isPrescriptionRequired: boolean;
      readonly name: string;
      readonly pharmaceuticalCentralNumberList: ReadonlyArray<{
        readonly name: string;
        readonly pharmaceuticalCentralNumber: string;
        readonly price: string;
        readonly quantity: string;
        readonly unit: string;
      }>;
      readonly pharmaceuticalForm: {
        readonly ifaCode: string;
        readonly name: string;
      };
      readonly productId: number;
    }>;
  };
  readonly de_substances: {
    readonly result?: ReadonlyArray<{
      readonly nameHtml: string;
      readonly substanceId: number;
    }>;
  };
};
export type useDeMedicationSearchQuery = {
  response: useDeMedicationSearchQuery$data;
  variables: useDeMedicationSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "searchTerm",
    "variableName": "searchTerm"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PreparationResponse",
      "kind": "LinkedField",
      "name": "result",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "composition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrescriptionRequired",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PharmaceuticalCentralNumberResponse",
          "kind": "LinkedField",
          "name": "pharmaceuticalCentralNumberList",
          "plural": true,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "price",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pharmaceuticalCentralNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PharmaceuticalFormResponse",
          "kind": "LinkedField",
          "name": "pharmaceuticalForm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ifaCode",
              "storageKey": null
            },
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SuccessPreparationResult",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SubstanceResponse",
      "kind": "LinkedField",
      "name": "result",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "substanceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameHtml",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SuccessSubstanceResult",
  "abstractKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeMedicationSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "de_preparations",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "de_substances",
        "plural": false,
        "selections": [
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDeMedicationSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "de_preparations",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "de_substances",
        "plural": false,
        "selections": [
          (v5/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "c3a67771732db6cf4daf1278e005a576",
    "metadata": {},
    "name": "useDeMedicationSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b87262c6433adcaa5d87868dcf903af7";

export default node;
